import axios from "axios";
import { BASE_URL } from "./Constant";

const HttpClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    // "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export default HttpClient;

export const getIPAddress = async () => {
  try {
    const localIP = await new Promise((resolve, reject) => {
      const pc = new RTCPeerConnection({ iceServers: [] });
      pc.createDataChannel("");
      pc.createOffer().then((offer) => pc.setLocalDescription(offer));

      pc.onicecandidate = (event) => {
        if (!event.candidate) return;
        const ipMatch = event.candidate.candidate.match(
          /(\d{1,3}\.){3}\d{1,3}/,
        );
        if (ipMatch && !ipMatch[0].startsWith("0.")) {
          resolve(ipMatch[0]);
          pc.close();
        }
      };

      setTimeout(() => reject(new Error("WebRTC timeout")), 1000);
    });

    if (localIP) return localIP;
  } catch {
    console.warn("WebRTC blocked (likely Brave), trying public API...");
  }

  try {
    const res = await fetch("https://api4.ipify.org?format=json");
    const data = await res.json();
    return data.ip;
  } catch {
    console.error("Public API also failed");
    return "Unknown IP";
  }
};

//  getIPAddress;
